module.exports = __webpack_public_path__ + "img/tips-support-icon.eb95b399.svg";